<template lang="html">
  <div id="benefits-page">

    <section class="main-section">
      <div class="placed-backg box-image"></div>

      <div class="container oversized-container">
        <div class="row">
          <div class="col-lg-5 col-xl-6 col-image"></div>

          <div class="col-lg-7 col-xl-6 col-text">
            <h1 class="mb-2 title">Hacemos realidad lo imposible</h1>
            <ul class="list-1">
              <li>Sin puntos, sin volumen y sin rangos</li>
              <li>No se te paga con producto</li>
              <li>Sin candados que frenan tu crecimiento</li>
              <li>Sin acumulación de inventario</li>
              <li>Sin plan dificil y rebuscado</li>
              <li>Sin consumo caro</li>
              <li>Inversiónes pequeñas</li>
            </ul>

            <p class="mt-1">
              <router-link class="t-150 btn-buy" to="/productos">¡Comprar ahora!</router-link>
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="benefits-section">
      <div class="container">
        <h2 class="text-center title-2">Te pagamos lo más justo</h2>

        <div class="row justify-content-center">
          <div class="col-9 col-sm-6 col-md-4 col-info">
            <div class="box-icon">
              <img src="public/images/pages/benefits/benefit-1.svg">
            </div>

            <h4>10X</h4>
            <h5>+ Dinero</h5>
            <!-- <p>
              Accede a todo el contenido sin restricciones por una tarifa fija.
            </p> -->
          </div>

          <div class="col-9 col-sm-6 col-md-4 col-info">
            <div class="box-icon">
              <img src="public/images/pages/benefits/benefit-2.svg">
            </div>

            <h4>10X</h4>
            <h5>- Personas</h5>
          </div>

          <div class="col-9 col-sm-6 col-md-4 col-info">
            <div class="box-icon">
              <img src="public/images/pages/benefits/benefit-3.svg">
            </div>

            <h4>10N GRATIS</h4>
            <h5>En el nivel 1 y 2</h5>
          </div>
        </div>
      </div>
    </section>

    <section class="benefits-2-section">
      <div class="container">
        <div class="row">
          <div class="col-12 col-title">
            <h2 class="title-s1">Beneficios que superan la ficción</h2>
          </div>
        </div>

        <div class="row row-info">
          <div class="col-sm-3 col-lg-2 col-icon">
            <img src="public/images/pages/benefits/icon-b-1.svg">
          </div>

          <div class="col col-sm-8 col-lg-9 col-text">
            <h5>Afiliación y reconsumos más bajo de su genero</h5>
          </div>
        </div>

        <div class="row row-info">
          <div class="col-sm-3 col-lg-2 col-icon">
            <img src="public/images/pages/benefits/icon-b-2.svg">
          </div>

          <div class="col col-sm-8 col-lg-9 col-text">
            <h5>El bono de afiliación vitalicio más generoso de la historia, pago por semana o mismo día</h5>
          </div>
        </div>

        <div class="row row-info">
          <div class="col-sm-3 col-lg-2 col-icon">
            <img src="public/images/pages/benefits/icon-b-3.svg">
          </div>

          <div class="col col-sm-8 col-lg-9 col-text">
            <h5>2 negocios en 1</h5>
          </div>
        </div>

        <div class="row row-info">
          <div class="col-sm-3 col-lg-2 col-icon">
            <img src="public/images/pages/benefits/icon-b-4.svg">
          </div>

          <div class="col col-sm-8 col-lg-9 col-text">
            <h5>Inmejorables ganancias de inicio y en construcción</h5>
          </div>
        </div>

        <div class="row row-info">
          <div class="col-sm-3 col-lg-2 col-icon">
            <img src="public/images/pages/benefits/icon-b-5.svg">
          </div>

          <div class="col col-sm-8 col-lg-9 col-text">
            <h5>Ganas 10x más dinero con 10x menos afiliados</h5>
          </div>
        </div>

        <div class="row row-info">
          <div class="col-sm-3 col-lg-2 col-icon">
            <img src="public/images/pages/benefits/icon-b-6.svg">
          </div>

          <div class="col col-sm-8 col-lg-9 col-text">
            <h5>10 Niveles gratis compactados en nivel 1 y 2 + nivel 3 plus</h5>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
